export default {"src":"/_next/static/media/si.d9b84a94.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};